<template>
  <div class="comment">

    <div class="data-wrapper">
      <div class="metadata">
        <v-avatar :size="32" class="avatar">
          <img v-if="comment.author.photoUrl" :src="comment.author.photoUrl" />
          <v-icon v-else x-large class="default-avatar">account_circle</v-icon>
        </v-avatar>

        {{ comment.author.name }} {{ comment.date }}
      </div>

      <div class="text">
        <vue-markdown>{{ comment.text }}</vue-markdown>
      </div>

      <div class="links">
        <v-btn flat icon v-if="!replying" @click="replying = true" title="Відповісти">
            <v-icon>reply</v-icon>
        </v-btn>
        <!-- <v-btn flat small outline @click="replying = true">
            Reply
        </v-btn> -->
      </div>

      <comment-form v-if="replying" :postId="postId" :parentComment="comment" :auth="auth" @cancel="replying = false" class="comment-form"></comment-form>
    </div>
  </div>
</template>

<script>

import VueMarkdown from 'vue-markdown';
import CommentForm from './CommentForm';

export default {
  name: 'comment',
  components: {
    VueMarkdown,
    CommentForm,
  },
  props: {
    comment: {
      type: Object,
      required: true,
    },
    postId: {
      required: true,
    },
    auth: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      replying: false,
    };
  },
};

</script>

<style scoped>

.comment {
  /*display: flex;*/
  /*flex-direction: row;*/
  margin: 15px 0;
  padding: 20px 25px 10px 25px;
}

.avatar {
  margin: 3px 10px 0 0;
}

.data-wrapper {
  flex: 1;
}

.metadata {
  font-size: 16px;
  color: #777;
}

.text {
  margin: 15px 0;
}

.links {
  margin: -5px;
}

.comment-form {
  margin: 40px 20px 20px 40px;
}

</style>



// WEBPACK FOOTER //
// src/components/Comments/Comment.vue